import ReactDOM from 'react-dom';

import { App } from './App';
import { makerStore } from './makerStore';
import { withProviders } from './withProviders';
const { store, history } = makerStore();

ReactDOM.render(withProviders(App, store, history), document.getElementById('root'));
